/**
 * @file price-dimensions.tsx
 * @module app/modules/uProcure/products/edit-master-product/price-dimensions
 * @description Implements the price dimensions interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { useEffect, useState } from 'react';
import { Button, Card, Col, OverlayTrigger, Row } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { Link } from 'react-router-dom';
import AddMore from '../../../../../_admin/assets/media/product/addMore.png';
import BlurCartoon from '../../../../../_admin/assets/media/product/blurCartoon.webp';
import Cartoon from '../../../../../_admin/assets/media/product/cartoon.png';
import Dimension from '../../../../../_admin/assets/media/product/dimension.webp';
import Remove from '../../../../../_admin/assets/media/product/remove.png';
import clsx from 'clsx';
import arrowDown from '../../../../../_admin/assets/media/svg_uTrade/down-arrow.svg';
import arrowUp from '../../../../../_admin/assets/media/svg_uTrade/up-arrow.svg';
import { error } from '../../../../../Global/toast';
import {
  CartonWithDozens,
  CartonWithPieces,
  Dozen,
  Piece,
} from '../../../../../utils/constants';
const PriceDimesions = (props: any) => {
  const [generalData, setGeneralData] = useState(
    JSON.parse(JSON.stringify(props.generalData))
  );
  const [accindex, setAccIndex] = useState('-1');
  const [generalDataValidation, setGeneralDataValidation] = useState<any>(
    props.validations
  );
  const handleChecked = (index: any, combinationIndex: number) => {
    let temp = JSON.parse(JSON.stringify({ ...generalData }));
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    // temp.combinations[combinationIndex].dimensions.product[index].isChecked =
    //   !temp.combinations[combinationIndex].dimensions.product[index].isChecked;
    const product =
      temp.combinations[combinationIndex].dimensions.product[index];
    // Handle checking/unchecking the current product
    product.isChecked = !product.isChecked;
    const selectedIds = temp.combinations[combinationIndex].dimensions.product
      .filter((item: any) => item.isChecked)
      .map((item: any) => item.id);
    if (selectedIds.includes(CartonWithDozens) && selectedIds.includes(Dozen)) {
      temp.combinations[combinationIndex].dimensions.cartoonDozens =
        temp.combinations[combinationIndex].dimensions.cartoonDozens;
      temp.combinations[combinationIndex].dimensions.piecesDozens =
        temp.combinations[combinationIndex].dimensions.piecesDozens;
      if (!selectedIds.includes(CartonWithPieces)) {
        temp.combinations[combinationIndex].dimensions.cartoonPieces = '0';
      }
    } else if (selectedIds.includes(CartonWithDozens)) {
      temp.combinations[combinationIndex].dimensions.cartoonDozens =
        temp.combinations[combinationIndex].dimensions.cartoonDozens;
      temp.combinations[combinationIndex].dimensions.piecesDozens =
        temp.combinations[combinationIndex].dimensions.piecesDozens;
      temp.combinations[combinationIndex].dimensions.cartoonPieces = '0';
      if (!selectedIds.includes(CartonWithPieces)) {
        temp.combinations[combinationIndex].dimensions.cartoonPieces = '0';
      }
    } else if (selectedIds.includes(Dozen)) {
      temp.combinations[combinationIndex].dimensions.cartoonDozens = '0';
      temp.combinations[combinationIndex].dimensions.piecesDozens =
        temp.combinations[combinationIndex].dimensions.piecesDozens;
      if (!selectedIds.includes(CartonWithPieces)) {
        temp.combinations[combinationIndex].dimensions.cartoonPieces = '0';
      }
    } else if (selectedIds.includes(CartonWithPieces)) {
      temp.combinations[combinationIndex].dimensions.cartoonPieces =
        temp.combinations[combinationIndex].dimensions.cartoonPieces;
    } else if (
      !selectedIds.includes(Dozen) ||
      !selectedIds.includes(CartonWithDozens) ||
      !selectedIds.includes(CartonWithPieces)
    ) {
      if (!selectedIds.includes(CartonWithDozens)) {
        temp.combinations[combinationIndex].dimensions.cartoonDozens = '0';
      }
      if (!selectedIds.includes(Dozen)) {
        temp.combinations[combinationIndex].dimensions.piecesDozens = '0';
      }
      if (!selectedIds.includes(CartonWithPieces)) {
        temp.combinations[combinationIndex].dimensions.cartoonPieces = '0';
      }
    }
    let allTrue = temp.combinations.some((combVal: any, index2: number) => {
      let result = combVal.dimensions.product.some(
        (pl: any) => pl.isChecked === true
      );
      if (result) {
        validationTemp.combinations[combinationIndex].validation = false;
      } else {
        validationTemp.combinations[combinationIndex].validation = true;
      }
      return result;
    });
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  useEffect(() => {
    props.onGeneralDataChange(generalData);
  }, [generalData]);
  useEffect(() => {
    props.onValidationChange(generalDataValidation);
  }, [generalDataValidation]);
  const handleAddMore = (combinationIndex: number, name: string) => {
    let temp = { ...generalData };
    let generalTemp = { ...generalData };
    const unique = generalTemp.combinations[combinationIndex].dimensions[
      name
    ].reduce((accumulator: any, current: any) => {
      if (
        !accumulator.find(
          (item: any) =>
            parseInt(item.min) === parseInt(current.min) ||
            parseInt(item.max) === parseInt(current.max)
        )
      ) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    if (
      unique.length <
      generalTemp.combinations[combinationIndex].dimensions[name].length
    ) {
      error('Discount quantity overlaps');
    } else {
      let result = temp.combinations[combinationIndex].dimensions[name].every(
        (val: any) => {
          return (
            val.min !== null &&
            val.min !== 0 &&
            val.max !== null &&
            val.max !== 0 &&
            val.discount !== null
          );
        }
      );
      if (result) {
        temp.combinations[combinationIndex].dimensions[name].push({
          min:
            parseInt(
              temp.combinations[combinationIndex].dimensions[name][
                temp.combinations[combinationIndex].dimensions[name].length - 1
              ].max
            ) + 1,
          max:
            parseInt(
              temp.combinations[combinationIndex].dimensions[name][
                temp.combinations[combinationIndex].dimensions[name].length - 1
              ].max
            ) + 5,
          discount: null,
        });
      }
    }
    setGeneralData(temp);
  };
  const handleQuantityChange = (
    value: any,
    combinationIndex: number,
    name: string,
    index: number,
    param: string
  ) => {
    let temp = { ...generalData };
    temp.combinations[combinationIndex].dimensions[name][index][param] = value;
    setGeneralData(temp);
  };
  const handleRemove = async (
    combinationIndex: any,
    index: any,
    name: string
  ) => {
    let temp = { ...generalData };
    temp.combinations[combinationIndex].dimensions[name].splice(index, 1);
    setGeneralData(temp);
  };
  const popover = (
    <Popover id="popover-basic  ">
      <Popover.Body className="p-2 bg-black border-r10px">
        <img
          src={Dimension}
          height={214}
          width={250}
          alt=""
        />
      </Popover.Body>
    </Popover>
  );
  const handleChange = async (
    value: any,
    combinationIndex: number,
    name: string
  ) => {
    let temp = JSON.parse(JSON.stringify({ ...generalData }));
    temp.combinations[combinationIndex].dimensions[name] = value;
    setGeneralData(temp);
    await checkValidation(temp, name, combinationIndex);
  };
  const checkValidation = async (
    generalTemp: any,
    name: string,
    combinationIndex: number
  ) => {
    let tempValidation = { ...generalDataValidation };
    switch (name) {
      case 'cartoonDimenisionL':
      case 'cartoonDimenisionW':
      case 'cartoonWeight':
      case 'cartoonPrice':
      case 'cartoonDimenisionH':
      case 'dozenDimenisionH':
      case 'dozenDimenisionL':
      case 'dozenDimenisionW':
      case 'dozenPrice':
      case 'dozenWeight':
      case 'pieceDimenisionH':
      case 'pieceDimenisionL':
      case 'pieceDimenisionW':
      case 'piecePrice':
      case 'cartoonDozens':
      case 'cartoonPieces':
      case 'piecesDozens':
      case 'pieceWeight':
        tempValidation.combinations[combinationIndex].dimensions[name] = false;
        if (
          generalTemp.combinations[combinationIndex].dimensions[name] === ''
        ) {
          tempValidation.combinations[combinationIndex].dimensions[name] = true;
        }
        break;
      case 'cartoonDiscountPrice':
        if (
          generalTemp.combinations[combinationIndex].dimensions[
            'cartoonDiscount'
          ] === '0'
        ) {
          if (
            generalTemp.combinations[combinationIndex].dimensions[
              'cartoonPrice'
            ] &&
            generalTemp.combinations[combinationIndex].dimensions[
              'cartoonPrice'
            ] !== ''
          ) {
            if (
              parseInt(
                generalTemp.combinations[combinationIndex].dimensions[
                  'cartoonDiscountPrice'
                ]
              ) >
              parseInt(
                generalTemp.combinations[combinationIndex].dimensions[
                  'cartoonPrice'
                ]
              )
            ) {
              tempValidation.combinations[combinationIndex].dimensions[name] =
                true;
            } else {
              tempValidation.combinations[combinationIndex].dimensions[name] =
                false;
            }
          }
        }
        break;
      case 'dozenDiscountPrice':
        if (
          generalTemp.combinations[combinationIndex].dimensions[
            'dozenDiscount'
          ] === '0'
        ) {
          if (
            generalTemp.combinations[combinationIndex].dimensions[
              'dozenPrice'
            ] &&
            generalTemp.combinations[combinationIndex].dimensions[
              'dozenPrice'
            ] !== ''
          ) {
            if (
              parseInt(
                generalTemp.combinations[combinationIndex].dimensions[
                  'dozenDiscountPrice'
                ]
              ) >
              parseInt(
                generalTemp.combinations[combinationIndex].dimensions[
                  'dozenPrice'
                ]
              )
            ) {
              tempValidation.combinations[combinationIndex].dimensions[name] =
                true;
            } else {
              tempValidation.combinations[combinationIndex].dimensions[name] =
                false;
            }
          }
        }
        break;
      case 'pieceDiscountPrice':
        if (
          generalTemp.combinations[combinationIndex].dimensions[
            'pieceDiscount'
          ] === '0'
        ) {
          if (
            generalTemp.combinations[combinationIndex].dimensions[
              'piecePrice'
            ] &&
            generalTemp.combinations[combinationIndex].dimensions[
              'piecePrice'
            ] !== ''
          ) {
            if (
              parseInt(
                generalTemp.combinations[combinationIndex].dimensions[
                  'pieceDiscountPrice'
                ]
              ) >
              parseInt(
                generalTemp.combinations[combinationIndex].dimensions[
                  'piecePrice'
                ]
              )
            ) {
              tempValidation.combinations[combinationIndex].dimensions[name] =
                true;
            } else {
              tempValidation.combinations[combinationIndex].dimensions[name] =
                false;
            }
          }
        }
        break;
      default:
      // code block
    }
    setGeneralDataValidation(tempValidation);
  };
  const handleOnKeyPress = (event: any, combinationIndex: number) => {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      event.preventDefault();
      return false;
    }
    return true;
  };
  const renderCartoonDetails = (
    dimension: any,
    combinationIndex: number,
    validation: any
  ) => {
    let cartoonDetails = (
      <>
        <Row className="p-6">
          <h2 className="fs-20 fw-bolder text-primary mb-6">
            Add carton details
          </h2>
          <Col lg={12}>
            <Row className="align-items-center">
              <Col md="auto">
                <div className="symbol symbol-lg-200px symbol-175px symbol-fixed bg-light position-relative">
                  <img
                    className="img-fluid"
                    src={Cartoon}
                    alt=""
                  />
                  <div className="text-center mt-3">
                    <OverlayTrigger
                      trigger="click"
                      placement="bottom"
                      overlay={popover}
                    >
                      <Link
                        to="#"
                        className="fs-14 fw-700"
                      >
                        How to measure?
                      </Link>
                    </OverlayTrigger>
                  </div>
                </div>
              </Col>
              <Col md={9}>
                <Row className="align-items-center mt-md-0 mt-5">
                  <Col lg={12}>
                    <Row>
                      <Col md={6}>
                        <Row className="align-items-center">
                          <Col
                            lg={4}
                            className="mb-3"
                          >
                            <label
                              htmlFor=""
                              className="fs-16 fw-500 mb-lg-0 mb-3 required"
                            >
                              Original price of a carton
                            </label>
                          </Col>
                          <Col
                            lg={8}
                            className="mb-3"
                          >
                            <div className="input-group input-group-solid h-60px border">
                              <span
                                className={clsx(
                                  'input-group-text fs-16 fw-600 text-dark bg-white ',
                                  validation.cartoonPrice
                                    ? 'border-danger border-right-0'
                                    : 'border-0 '
                                )}
                                id="basic-addon1"
                              >
                                TSh
                              </span>
                              <input
                                type="text"
                                className={clsx(
                                  'form-control form-control-lg bg-white text-black fs-16 fw-600',
                                  validation.cartoonPrice
                                    ? 'border-danger border-left-0'
                                    : 'border-0 '
                                )}
                                placeholder="Original price"
                                value={dimension.cartoonPrice}
                                onChange={(event: any) => {
                                  handleChange(
                                    event.target.value,
                                    combinationIndex,
                                    'cartoonPrice'
                                  );
                                }}
                                onKeyPress={(event: any) => {
                                  handleOnKeyPress(event, combinationIndex);
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      {dimension.cartoonDiscount == '0' ? (
                        <Col md={6}>
                          <Row className="align-items-center">
                            <Col
                              lg={4}
                              className="mb-3"
                            >
                              <label
                                htmlFor=""
                                className="fs-16 fw-500"
                              >
                                Discounted price of a cartoon
                              </label>
                            </Col>
                            <Col
                              lg={8}
                              className="mb-3"
                            >
                              <div className="input-group input-group-solid h-60px border">
                                <span
                                  className={clsx(
                                    'input-group-text fs-16 fw-600 text-dark bg-white ',
                                    validation.cartoonDiscountPrice
                                      ? 'border-danger border-right-0'
                                      : 'border-0 '
                                  )}
                                  id="basic-addon1"
                                >
                                  TSh
                                </span>
                                <input
                                  type="text"
                                  className={clsx(
                                    'form-control form-control-lg bg-white text-black fs-16 fw-600',
                                    validation.cartoonDiscountPrice
                                      ? 'border-danger border-left-0'
                                      : 'border-0 '
                                  )}
                                  placeholder="Discount price"
                                  value={dimension.cartoonDiscountPrice}
                                  onChange={(event: any) => {
                                    handleChange(
                                      event.target.value,
                                      combinationIndex,
                                      'cartoonDiscountPrice'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                              </div>
                            </Col>
                            {validation.cartoonDiscountPrice ? (
                              <>
                                <Col
                                  lg={4}
                                  className="mb-3"
                                ></Col>
                                <Col
                                  lg={8}
                                  className="mb-3"
                                >
                                  <label
                                    htmlFor=""
                                    className="fs-12 fw-500 text-danger"
                                  >
                                    Discount Price must be less than or equal to
                                    original price
                                  </label>
                                </Col>
                              </>
                            ) : (
                              <></>
                            )}
                          </Row>
                        </Col>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Col>
                  <Col md={12}>
                    <label
                      htmlFor=""
                      className="fs-16 fw-500 mb-3 mt-2"
                    >
                      Do you offer discount by total number of quantities?
                    </label>
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <div className="form-check form-check-custom form-check-solid">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="0"
                            id="flexRadioChecked"
                            checked={dimension.cartoonDiscount == '0'}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'cartoonDiscount'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <label className="form-check-label fs-16 fw-600 text-dark">
                            No
                          </label>
                        </div>
                      </Col>
                      <Col xs="auto">
                        <div className="form-check form-check-custom form-check-solid">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="1"
                            id="flexRadioChecked"
                            checked={dimension.cartoonDiscount == '1'}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'cartoonDiscount'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <label className="form-check-label fs-16 fw-600 text-dark">
                            Yes
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    lg={12}
                    className="mt-3"
                  >
                    <Row className="align-items-center mb-5">
                      <Col
                        md={12}
                        lg={3}
                      >
                        <label className="fs-16 fw-500 mt-4 mb-4">
                          Carton dimensions (cm)
                        </label>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            // className="form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.cartoonDimenisionL
                                ? 'border-danger'
                                : ''
                            )}
                            placeholder="Length"
                            value={dimension.cartoonDimenisionL}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'cartoonDimenisionL'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            L
                          </span>
                        </div>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.cartoonDimenisionW
                                ? 'border-danger'
                                : ''
                            )}
                            placeholder="Width"
                            value={dimension.cartoonDimenisionW}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'cartoonDimenisionW'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            W
                          </span>
                        </div>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.cartoonDimenisionH
                                ? 'border-danger'
                                : ''
                            )}
                            placeholder="Height"
                            value={dimension.cartoonDimenisionH}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'cartoonDimenisionH'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            H
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="align-items-center">
                      <Col
                        lg={3}
                        md={12}
                      >
                        <label className="fs-16 fw-500 mt-sm-4 mt-0 mb-4">
                          Carton weight (kg)
                        </label>
                      </Col>
                      <Col
                        lg={2}
                        md={6}
                      >
                        <input
                          type="text"
                          className={clsx(
                            'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                            validation.cartoonWeight ? 'border-danger' : ''
                          )}
                          placeholder="Weight"
                          value={dimension.cartoonWeight}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value,
                              combinationIndex,
                              'cartoonWeight'
                            );
                          }}
                          onKeyPress={(event: any) => {
                            handleOnKeyPress(event, combinationIndex);
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        {dimension.cartoonDiscount == '1' ? (
          <>
            <div className="separator my-2"></div>
            <Row className="p-6 pb-8">
              <Col lg={12}>
                <div>
                  <h2 className="fs-22 fw-bolder text-dark">
                    Discount by total number of quantities
                  </h2>
                </div>
                {dimension.cartoonQuantities.map((val: any, index: number) => {
                  return (
                    <>
                      <Row className="align-items-center mt-6">
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-5"
                        >
                          <Row className="align-items-center">
                            <Col md={5}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Minimum qty.
                              </label>
                            </Col>
                            <Col md={7}>
                              <div className="input-group input-group-solid h-60px border">
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                  placeholder="Original price"
                                  value={val.min}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'cartoonQuantities',
                                      index,
                                      'min'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                                <span
                                  className="input-group-text fs-16 fw-500 text-gray bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  {' '}
                                  carton
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-5"
                        >
                          <Row className="align-items-center">
                            <Col md={5}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Maximum qty.
                              </label>
                            </Col>
                            <Col md={7}>
                              <div className="input-group input-group-solid h-60px border">
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                  placeholder="Original price"
                                  value={val.max}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'cartoonQuantities',
                                      index,
                                      'max'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                                <span
                                  className="input-group-text fs-16 fw-500 text-gray bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  {' '}
                                  carton
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={5}
                          xs={10}
                        >
                          <Row className="align-items-center">
                            <Col md={4}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Discounted price of a carton
                              </label>
                            </Col>
                            <Col md={8}>
                              <div className="input-group input-group-solid h-60px border">
                                <span
                                  className="input-group-text fs-16 fw-600 text-dark bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  TSh
                                </span>
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-600"
                                  placeholder="Type here..."
                                  value={val.discount}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'cartoonQuantities',
                                      index,
                                      'discount'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={'auto'}
                          xs={'auto'}
                          className="d-flex align-items-lg-end align-self-center"
                        >
                          {dimension.cartoonQuantities.length - 1 === index ? (
                            <img
                              src={AddMore}
                              height={35}
                              width={35}
                              alt=""
                              onClick={(e) => {
                                handleAddMore(
                                  combinationIndex,
                                  'cartoonQuantities'
                                );
                              }}
                            ></img>
                          ) : (
                            <img
                              src={Remove}
                              height={35}
                              width={35}
                              alt=""
                              onClick={(e) => {
                                handleRemove(
                                  combinationIndex,
                                  index,
                                  'cartoonQuantities'
                                );
                              }}
                            ></img>
                          )}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )}
      </>
    );
    return cartoonDetails;
  };
  const renderDozenDetails = (
    dimension: any,
    combinationIndex: number,
    validation: any
  ) => {
    let dozenDetails = (
      <>
        <Row className="p-6">
          <h2 className="fs-20 fw-bolder text-primary mb-6">
            Add dozen details
          </h2>
          <Col lg={12}>
            <Row className="align-items-center">
              <Col md="auto">
                <div className="symbol symbol-lg-200px symbol-175px symbol-fixed position-relative">
                  <img
                    className="img-fluid bg-white border"
                    src={BlurCartoon}
                    alt=""
                  />
                  <div className="text-center mt-3">
                    <OverlayTrigger
                      trigger="click"
                      placement="bottom"
                      overlay={popover}
                    >
                      <Link
                        to="#"
                        className="fs-14 fw-700"
                      >
                        How to measure?
                      </Link>
                    </OverlayTrigger>
                  </div>
                </div>
              </Col>
              <Col md={9}>
                <Row className="align-items-center mt-md-0 mt-5">
                  <Col lg={12}>
                    <Row>
                      <Col md={6}>
                        <Row className="align-items-center">
                          <Col
                            lg={4}
                            className="mb-3"
                          >
                            <label
                              htmlFor=""
                              className="fs-16 fw-500 required"
                            >
                              Original price of a dozen
                            </label>
                          </Col>
                          <Col
                            lg={8}
                            className="mb-3"
                          >
                            <div className="input-group input-group-solid h-60px border">
                              <span
                                className={clsx(
                                  'input-group-text fs-16 fw-600 text-dark bg-white ',
                                  validation.dozenPrice
                                    ? 'border-danger border-right-0'
                                    : 'border-0 '
                                )}
                                id="basic-addon1"
                              >
                                TSh
                              </span>
                              <input
                                type="text"
                                className={clsx(
                                  'form-control form-control-lg bg-white text-black fs-16 fw-600',
                                  validation.dozenPrice
                                    ? 'border-danger border-left-0'
                                    : 'border-0'
                                )}
                                id="basic-addon1"
                                placeholder="Original price"
                                value={dimension.dozenPrice}
                                onChange={(event: any) => {
                                  handleChange(
                                    event.target.value,
                                    combinationIndex,
                                    'dozenPrice'
                                  );
                                }}
                                onKeyPress={(event: any) => {
                                  handleOnKeyPress(event, combinationIndex);
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      {dimension.dozenDiscount == '0' ? (
                        <Col md={6}>
                          <Row className="align-items-center">
                            <Col
                              lg={4}
                              className="mb-3"
                            >
                              <label
                                htmlFor=""
                                className="fs-16 fw-500"
                              >
                                Discounted price of a dozen
                              </label>
                            </Col>
                            <Col
                              lg={8}
                              className="mb-3"
                            >
                              <div className="input-group input-group-solid h-60px border">
                                <span
                                  className={clsx(
                                    'input-group-text fs-16 fw-600 text-dark bg-white ',
                                    'border-0 '
                                  )}
                                  id="basic-addon1"
                                >
                                  TSh
                                </span>
                                <input
                                  type="text"
                                  className={clsx(
                                    'form-control form-control-lg bg-white text-black fs-16 fw-600',
                                    'border-0'
                                  )}
                                  placeholder="Discount price"
                                  value={dimension.dozenDiscountPrice}
                                  onChange={(event: any) => {
                                    handleChange(
                                      event.target.value,
                                      combinationIndex,
                                      'dozenDiscountPrice'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                              </div>
                            </Col>
                            {validation.dozenDiscountPrice ? (
                              <>
                                <Col
                                  lg={4}
                                  className="mb-3"
                                ></Col>
                                <Col
                                  lg={8}
                                  className="mb-3"
                                >
                                  <label
                                    htmlFor=""
                                    className="fs-12 fw-500 text-danger"
                                  >
                                    Discount Price must be less than or equal to
                                    original price
                                  </label>
                                </Col>
                              </>
                            ) : (
                              <></>
                            )}
                          </Row>
                        </Col>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Col>
                  <Col md={12}>
                    <label
                      htmlFor=""
                      className="fs-16 fw-500 mb-3 mt-2"
                    >
                      Do you offer discount by total number of quantities?
                    </label>
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <div className="form-check form-check-custom form-check-solid">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="0"
                            id="flexRadioChecked"
                            checked={dimension.dozenDiscount == '0'}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'dozenDiscount'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <label className="form-check-label fs-16 fw-600 text-dark">
                            No
                          </label>
                        </div>
                      </Col>
                      <Col xs="auto">
                        <div className="form-check form-check-custom form-check-solid">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="1"
                            id="flexRadioChecked"
                            checked={dimension.dozenDiscount == '1'}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'dozenDiscount'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <label className="form-check-label fs-16 fw-600 text-dark">
                            Yes
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    lg={12}
                    className="mt-3"
                  >
                    <Row className="align-items-center mb-5">
                      <Col
                        md={12}
                        lg={3}
                      >
                        <label className="fs-16 fw-500 mt-4 mb-4">
                          Dozen dimensions (cm)
                        </label>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.dozenDimenisionL ? 'border-danger' : ''
                            )}
                            placeholder="Length"
                            value={dimension.dozenDimenisionL}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'dozenDimenisionL'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            L
                          </span>
                        </div>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.dozenDimenisionW ? 'border-danger' : ''
                            )}
                            placeholder="Width"
                            value={dimension.dozenDimenisionW}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'dozenDimenisionW'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            W
                          </span>
                        </div>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.dozenDimenisionH ? 'border-danger' : ''
                            )}
                            placeholder="Height"
                            value={dimension.dozenDimenisionH}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'dozenDimenisionH'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            H
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="align-items-center">
                      <Col
                        lg={3}
                        md={12}
                      >
                        <label className="fs-16 fw-500 mt-sm-4 mt-0 mb-4">
                          Dozen weight (kg)
                        </label>
                      </Col>
                      <Col
                        lg={2}
                        md={6}
                      >
                        <input
                          type="text"
                          placeholder="Weight"
                          className={clsx(
                            'form-control form-control-lg border border-r8px bg-white text-black h-60px fs-16 fw-500',
                            validation.dozenWeight ? 'border-danger' : ''
                          )}
                          value={dimension.dozenWeight}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value,
                              combinationIndex,
                              'dozenWeight'
                            );
                          }}
                          onKeyPress={(event: any) => {
                            handleOnKeyPress(event, combinationIndex);
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        {dimension.dozenDiscount == '1' ? (
          <>
            <div className="separator my-2"></div>
            <Row className="p-6 pb-8">
              <Col lg={12}>
                <div>
                  <h2 className="fs-22 fw-bolder text-dark">
                    Discount by total number of quantities
                  </h2>
                </div>
                {dimension.dozenQuantities.map((val: any, index: number) => {
                  return (
                    <>
                      <Row className="align-items-center mt-6">
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-5"
                        >
                          <Row className="align-items-center">
                            <Col md={5}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Minimum qty.
                              </label>
                            </Col>
                            <Col md={7}>
                              <div className="input-group input-group-solid h-60px border">
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                  placeholder="Original price"
                                  value={val.min}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'dozenQuantities',
                                      index,
                                      'min'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                                <span
                                  className="input-group-text fs-16 fw-500 text-gray bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  dozen
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-5"
                        >
                          <Row className="align-items-center">
                            <Col md={5}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Maximum qty.
                              </label>
                            </Col>
                            <Col md={7}>
                              <div className="input-group input-group-solid h-60px border">
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                  placeholder="Original price"
                                  value={val.max}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'dozenQuantities',
                                      index,
                                      'max'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                                <span
                                  className="input-group-text fs-16 fw-500 text-gray bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  dozen
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={5}
                          xs={10}
                        >
                          <Row className="align-items-center">
                            <Col md={4}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Discounted price of a dozen
                              </label>
                            </Col>
                            <Col md={8}>
                              <div className="input-group input-group-solid h-60px border">
                                <span
                                  className="input-group-text fs-16 fw-600 text-dark bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  TSh
                                </span>
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-600"
                                  placeholder="Type here..."
                                  value={val.discount}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'dozenQuantities',
                                      index,
                                      'discount'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={'auto'}
                          xs={'auto'}
                          className="d-flex align-items-lg-end align-self-center"
                        >
                          {dimension.dozenQuantities.length - 1 === index ? (
                            <img
                              src={AddMore}
                              height={35}
                              width={35}
                              alt=""
                              onClick={(e) => {
                                handleAddMore(
                                  combinationIndex,
                                  'dozenQuantities'
                                );
                              }}
                            ></img>
                          ) : (
                            <img
                              src={Remove}
                              height={35}
                              width={35}
                              alt=""
                              onClick={(e) => {
                                handleRemove(
                                  combinationIndex,
                                  index,
                                  'dozenQuantities'
                                );
                              }}
                            ></img>
                          )}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )}
      </>
    );
    return dozenDetails;
  };
  const renderPiecesDetails = (
    dimension: any,
    combinationIndex: number,
    validation: any
  ) => {
    let piecesDetails = (
      <>
        <Row className="p-6">
          <h2 className="fs-20 fw-bolder text-primary mb-6">
            Add piece details
          </h2>
          <Col lg={12}>
            <Row className="align-items-center">
              <Col md="auto">
                <div className="symbol symbol-lg-200px symbol-175px symbol-fixed position-relative">
                  <img
                    className="img-fluid bg-white border"
                    src={BlurCartoon}
                    alt=""
                  />
                  <div className="text-center mt-3">
                    <OverlayTrigger
                      trigger="click"
                      placement="bottom"
                      overlay={popover}
                    >
                      <Link
                        to="#"
                        className="fs-14 fw-700"
                      >
                        How to measure?
                      </Link>
                    </OverlayTrigger>
                  </div>
                </div>
              </Col>
              <Col md={9}>
                <Row className="align-items-center mt-md-0 mt-5">
                  <Col lg={12}>
                    <Row>
                      <Col md={6}>
                        <Row className="align-items-center">
                          <Col
                            lg={4}
                            className="mb-3"
                          >
                            <label
                              htmlFor=""
                              className="fs-16 fw-500 required"
                            >
                              Original price of a piece
                            </label>
                          </Col>
                          <Col
                            lg={8}
                            className="mb-3"
                          >
                            <div className="input-group input-group-solid h-60px border">
                              <span
                                // className="input-group-text fs-16 fw-600 text-dark bg-white border-0 "
                                className={clsx(
                                  'input-group-text fs-16 fw-600 text-dark bg-white ',
                                  validation.piecePrice
                                    ? 'border-danger border-right-0'
                                    : 'border-0 '
                                )}
                                id="basic-addon1"
                              >
                                TSh
                              </span>
                              <input
                                type="text"
                                className={clsx(
                                  'form-control form-control-lg bg-white text-black fs-16 fw-600 ',
                                  validation.piecePrice
                                    ? 'border-danger border-left-0'
                                    : 'border-0 '
                                )}
                                placeholder="Original price"
                                value={dimension.piecePrice}
                                onChange={(event: any) => {
                                  handleChange(
                                    event.target.value,
                                    combinationIndex,
                                    'piecePrice'
                                  );
                                }}
                                onKeyPress={(event: any) => {
                                  handleOnKeyPress(event, combinationIndex);
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      {dimension.pieceDiscount == '0' ? (
                        <Col md={6}>
                          <Row className="align-items-center">
                            <Col
                              lg={4}
                              className="mb-3"
                            >
                              <label
                                htmlFor=""
                                className="fs-16 fw-500"
                              >
                                Discounted price of a piece
                              </label>
                            </Col>
                            <Col
                              lg={8}
                              className="mb-3"
                            >
                              <div className="input-group input-group-solid h-60px border">
                                <span
                                  className={clsx(
                                    'input-group-text fs-16 fw-600 text-dark bg-white',
                                    validation.pieceDiscountPrice
                                      ? 'border-danger border-right-0'
                                      : 'border-0 '
                                  )}
                                  id="basic-addon1"
                                >
                                  TSh
                                </span>
                                <input
                                  type="text"
                                  className={clsx(
                                    'form-control form-control-lg bg-white text-black fs-16 fw-600 ',
                                    validation.pieceDiscountPrice
                                      ? 'border-danger border-left-0'
                                      : 'border-0 '
                                  )}
                                  placeholder="Original price"
                                  value={dimension.pieceDiscountPrice}
                                  onChange={(event: any) => {
                                    handleChange(
                                      event.target.value,
                                      combinationIndex,
                                      'pieceDiscountPrice'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                              </div>
                            </Col>
                            {validation.pieceDiscountPrice ? (
                              <>
                                <Col
                                  lg={4}
                                  className="mb-3"
                                ></Col>
                                <Col
                                  lg={8}
                                  className="mb-3"
                                >
                                  <label
                                    htmlFor=""
                                    className="fs-12 fw-500 text-danger"
                                  >
                                    Discount Price must be less than or equal to
                                    original price
                                  </label>
                                </Col>
                              </>
                            ) : (
                              <></>
                            )}
                          </Row>
                        </Col>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Col>
                  <Col md={12}>
                    <label
                      htmlFor=""
                      className="fs-16 fw-500 mb-3 mt-2"
                    >
                      Do you offer discount by total number of quantities?
                    </label>
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <div className="form-check form-check-custom form-check-solid">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="0"
                            id="flexRadioChecked"
                            checked={dimension.pieceDiscount == '0'}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'pieceDiscount'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <label className="form-check-label fs-16 fw-600 text-dark">
                            No
                          </label>
                        </div>
                      </Col>
                      <Col xs="auto">
                        <div className="form-check form-check-custom form-check-solid">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="1"
                            id="flexRadioChecked"
                            checked={dimension.pieceDiscount == '1'}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'pieceDiscount'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <label className="form-check-label fs-16 fw-600 text-dark">
                            Yes
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    lg={12}
                    className="mt-3"
                  >
                    <Row className="align-items-center mb-5">
                      <Col
                        md={12}
                        lg={3}
                      >
                        <label className="fs-16 fw-500 mt-4 mb-4">
                          Piece dimensions (cm)
                        </label>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.pieceDimenisionL ? 'border-danger' : ''
                            )}
                            placeholder="Length"
                            value={dimension.pieceDimenisionL}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'pieceDimenisionL'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            L
                          </span>
                        </div>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.pieceDimenisionW ? 'border-danger' : ''
                            )}
                            placeholder="Width"
                            value={dimension.pieceDimenisionW}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'pieceDimenisionW'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            W
                          </span>
                        </div>
                      </Col>
                      <Col
                        sm={4}
                        lg={3}
                      >
                        <div className="input-group input-group-solid h-60px mb-sm-0 mb-5">
                          <input
                            type="text"
                            className={clsx(
                              'form-control form-control-lg border border-r8px bg-white text-black fs-16 fw-500',
                              validation.pieceDimenisionH ? 'border-danger' : ''
                            )}
                            placeholder="Height"
                            value={dimension.pieceDimenisionH}
                            onChange={(event: any) => {
                              handleChange(
                                event.target.value,
                                combinationIndex,
                                'pieceDimenisionH'
                              );
                            }}
                            onKeyPress={(event: any) => {
                              handleOnKeyPress(event, combinationIndex);
                            }}
                          />
                          <span
                            className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                            id="basic-addon1"
                          >
                            H
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="align-items-center">
                      <Col
                        lg={3}
                        md={12}
                      >
                        <label className="fs-16 fw-500 mt-sm-4 mt-0 mb-4">
                          Piece weight (kg)
                        </label>
                      </Col>
                      <Col
                        lg={2}
                        md={6}
                      >
                        <input
                          type="text"
                          className={clsx(
                            'form-control form-control-lg border border-r8px bg-white text-black h-60px fs-16 fw-500',
                            validation.pieceWeight ? 'border-danger' : ''
                          )}
                          placeholder="Weight"
                          value={dimension.pieceWeight}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value,
                              combinationIndex,
                              'pieceWeight'
                            );
                          }}
                          onKeyPress={(event: any) => {
                            handleOnKeyPress(event, combinationIndex);
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        {dimension.pieceDiscount == '1' ? (
          <>
            <div className="separator my-2"></div>
            <Row className="p-6 pb-8">
              <Col lg={12}>
                <div>
                  <h2 className="fs-22 fw-bolder text-dark">
                    Discount by total number of quantities
                  </h2>
                </div>
                {dimension.pieceQuantities.map((val: any, index: number) => {
                  return (
                    <>
                      <Row className="align-items-center mt-6">
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-5"
                        >
                          <Row className="align-items-center">
                            <Col md={5}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Minimum qty.
                              </label>
                            </Col>
                            <Col md={7}>
                              <div className="input-group input-group-solid h-60px border">
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                  placeholder="Original price"
                                  value={val.min}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'pieceQuantities',
                                      index,
                                      'min'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                                <span
                                  className="input-group-text fs-16 fw-500 text-gray bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  piece
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-5"
                        >
                          <Row className="align-items-center">
                            <Col md={5}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Maximum qty.
                              </label>
                            </Col>
                            <Col md={7}>
                              <div className="input-group input-group-solid h-60px border">
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                  placeholder="Original price"
                                  value={val.max}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'pieceQuantities',
                                      index,
                                      'max'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                                <span
                                  className="input-group-text fs-16 fw-500 text-gray bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  piece
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={5}
                          xs={10}
                        >
                          <Row className="align-items-center">
                            <Col md={4}>
                              <label className="fs-16 fw-500 mb-md-0 mb-3">
                                Discounted price of a piece
                              </label>
                            </Col>
                            <Col md={8}>
                              <div className="input-group input-group-solid h-60px border">
                                <span
                                  className="input-group-text fs-16 fw-600 text-dark bg-white border-0 "
                                  id="basic-addon1"
                                >
                                  TSh
                                </span>
                                <input
                                  type="text"
                                  className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-600"
                                  placeholder="Type here..."
                                  value={val.discount}
                                  onChange={(event: any) => {
                                    handleQuantityChange(
                                      event.target.value,
                                      combinationIndex,
                                      'pieceQuantities',
                                      index,
                                      'discount'
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    handleOnKeyPress(event, combinationIndex);
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={'auto'}
                          xs={'auto'}
                          className="d-flex align-items-lg-end align-self-center"
                        >
                          {dimension.pieceQuantities.length - 1 === index ? (
                            <img
                              src={AddMore}
                              height={35}
                              width={35}
                              alt=""
                              onClick={(e) => {
                                handleAddMore(
                                  combinationIndex,
                                  'pieceQuantities'
                                );
                              }}
                            ></img>
                          ) : (
                            <img
                              src={Remove}
                              height={35}
                              width={35}
                              alt=""
                              onClick={(e) => {
                                handleRemove(
                                  combinationIndex,
                                  index,
                                  'pieceQuantities'
                                );
                              }}
                            ></img>
                          )}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )}
      </>
    );
    return piecesDetails;
  };
  const renderCheckbox = (
    combinationProduct: any,
    combinationIndex: number,
    inventoryInfo: any
  ) => {
    let cb = combinationProduct.map((val: any, index: number) => {
      const matchingType = inventoryInfo[0].quantityTypes.find(
        (qtyType: any) => qtyType.type === parseInt(val.id)
      );
      const isDisabledDueToInventory =
        matchingType && matchingType.stockCount > 0;
      const isDisabledDueToCheckbox =
        (val.id === CartonWithDozens && combinationProduct[1].isChecked) ||
        (val.id === CartonWithPieces && combinationProduct[0].isChecked);
      const isDisabled = isDisabledDueToInventory || isDisabledDueToCheckbox;
      return (
        <div className="form-check form-check-custom form-check-solid mb-lg-0 me-6">
          <input
            className="form-check-input h-28px w-28px"
            type="checkbox"
            value={val.value}
            id={Math.random()
              .toString(36)
              .replace('0.', val.value || '')}
            checked={val.isChecked}
            disabled={isDisabled}
            onClick={() => {
              handleChecked(index, combinationIndex);
            }}
          />
          <label className="form-check-label text-dark fs-16 fw-600">
            {val.value}
          </label>
        </div>
      );
    });
    return cb;
  };
  const handleAccordion = (combinationIndex: number) => {
    // let temp = JSON.parse(JSON.stringify({ ...generalData }));
    let temp = JSON.parse(JSON.stringify({ ...props.generalData }));
    temp.combinations[combinationIndex].dimensions.isOpen =
      !temp.combinations[combinationIndex].dimensions.isOpen;
    setGeneralData(temp);
  };
  return (
    <>
      {props.generalData &&
        props.generalData.combinations.map((val: any, index: number) => {
          return (
            <>
              <Card className="p-0 mb-6">
                <Card.Header
                  className={clsx(
                    'border min-h-95px ',
                    val.dimensions.isOpen ? '' : 'border-r10px',
                    generalDataValidation.combinations[index].validation
                      ? 'border-danger'
                      : ''
                  )}
                >
                  <Row className="fs-16 fw-600 align-items-center w-100">
                    <Col
                      md
                      className="mb-md-0 mb-5 text-start"
                    >
                      <Button
                        className="btn-flush btn-white w-100 text-start"
                        variant=""
                      >
                        <span className={clsx('fs-22 fw-bolder text-dark')}>
                          {val.title.replace(/\s*\)\s*/g, ')')}
                        </span>
                      </Button>
                    </Col>
                    <Col md="auto">
                      {val.dimensions.isOpen ? (
                        <Button
                          variant="link"
                          className="btn-flush"
                          onClick={() => {
                            handleAccordion(index);
                          }}
                        >
                          <img
                            src={arrowUp}
                            alt=""
                          />
                        </Button>
                      ) : (
                        <Button
                          variant="link"
                          className="btn-flush"
                          onClick={() => {
                            handleAccordion(index);
                          }}
                        >
                          <img
                            src={arrowDown}
                            alt=""
                          />
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Card.Header>
                {val.dimensions.isOpen === true ? (
                  <>
                    <Card.Body
                      className={clsx(
                        'border border-top-0 border-r0px-top bg-light border-bottom',
                        generalDataValidation.combinations[index].validation
                          ? 'border-danger'
                          : ''
                      )}
                    >
                      <Row className="g-4">
                        <Col xs={12}>
                          <h5 className="text-primary fs-22 fw-bolder">
                            How the product is sold?
                          </h5>
                        </Col>
                        <Col xs={12}>
                          <div className="d-inline-flex">
                            {renderCheckbox(
                              val.dimensions.product,
                              index,
                              val.inventoryInfo
                            )}
                          </div>
                        </Col>
                        {val.dimensions.product.some((checkVal: any) => {
                          return checkVal.isChecked === true;
                        }) ? (
                          <>
                            {val.dimensions.product.find((checkVal: any) => {
                              return checkVal.id === CartonWithDozens
                                ? checkVal.isChecked === true
                                  ? true
                                  : false
                                : false;
                            }) ? (
                              <>
                                <Col md={6}>
                                  <Row className="align-items-center">
                                    <Col lg={4}>
                                      <label className="fs-16 fw-500 mb-lg-0 mb-3 required">
                                        How many dozens are in a carton?
                                      </label>
                                    </Col>
                                    <Col lg={5}>
                                      <div
                                        className={clsx(
                                          'input-group input-group-solid min-h-60px border',
                                          generalDataValidation.combinations[
                                            index
                                          ].dimensions.cartoonDozens
                                            ? 'border-danger'
                                            : ''
                                        )}
                                      >
                                        <input
                                          type="text"
                                          className={clsx(
                                            'form-control form-control-lg border-0 bg-white text-black fs-16 fw-500'
                                          )}
                                          placeholder="Type here..."
                                          value={val.dimensions.cartoonDozens}
                                          onChange={(event: any) => {
                                            handleChange(
                                              event.target.value,
                                              index,
                                              'cartoonDozens'
                                            );
                                          }}
                                          onKeyPress={(event: any) => {
                                            handleOnKeyPress(event, index);
                                          }}
                                        />
                                        <span
                                          className="input-group-text fs-16 fw-500 text-gray bg-white border-0 text-gray fs-16 fw-500"
                                          id="basic-addon1"
                                        >
                                          dozens
                                        </span>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col md={6}>
                                  <Row className="align-items-center">
                                    <Col lg={4}>
                                      <label className="fs-16 fw-500 mb-lg-0 mb-3 required">
                                        How many pieces are in a dozen?
                                      </label>
                                    </Col>
                                    <Col lg={5}>
                                      <div
                                        className={clsx(
                                          'input-group input-group-solid min-h-60px border',
                                          generalDataValidation.combinations[
                                            index
                                          ].dimensions.piecesDozens
                                            ? 'border-danger'
                                            : ''
                                        )}
                                      >
                                        <input
                                          type="text"
                                          className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                          placeholder="Type here..."
                                          value={val.dimensions.piecesDozens}
                                          onChange={(event: any) => {
                                            handleChange(
                                              event.target.value,
                                              index,
                                              'piecesDozens'
                                            );
                                          }}
                                          onKeyPress={(event: any) => {
                                            handleOnKeyPress(event, index);
                                          }}
                                        />
                                        <span
                                          className="input-group-text fs-16 fw-500 text-gray bg-white border-0 text-gray fs-16 fw-500"
                                          id="basic-addon1"
                                        >
                                          pieces
                                        </span>
                                      </div>
                                    </Col>{' '}
                                  </Row>
                                </Col>
                              </>
                            ) : (
                              <>
                                {' '}
                                {val.dimensions.product.find(
                                  (checkVal: any) => {
                                    return checkVal.id === Dozen
                                      ? checkVal.isChecked === true
                                        ? true
                                        : false
                                      : false;
                                  }
                                ) ? (
                                  <>
                                    <Col md={6}>
                                      <Row className="align-items-center">
                                        <Col lg={4}>
                                          <label className="fs-16 fw-500 mb-lg-0 mb-3 required">
                                            How many pieces are in a dozen?
                                          </label>
                                        </Col>
                                        <Col lg={5}>
                                          <div
                                            className={clsx(
                                              'input-group input-group-solid min-h-60px border',
                                              generalDataValidation
                                                .combinations[index].dimensions
                                                .piecesDozens
                                                ? 'border-danger'
                                                : ''
                                            )}
                                          >
                                            <input
                                              type="text"
                                              className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                              placeholder="Type here..."
                                              value={
                                                val.dimensions.piecesDozens
                                              }
                                              onChange={(event: any) => {
                                                handleChange(
                                                  event.target.value,
                                                  index,
                                                  'piecesDozens'
                                                );
                                              }}
                                              onKeyPress={(event: any) => {
                                                handleOnKeyPress(event, index);
                                              }}
                                            />
                                            <span
                                              className="input-group-text fs-16 fw-500 text-gray bg-white border-0 text-gray fs-16 fw-500"
                                              id="basic-addon1"
                                            >
                                              pieces
                                            </span>
                                          </div>
                                        </Col>{' '}
                                      </Row>
                                    </Col>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {val.dimensions.product.find(
                                  (checkVal: any) => {
                                    return checkVal.id === CartonWithPieces
                                      ? checkVal.isChecked === true
                                        ? true
                                        : false
                                      : false;
                                  }
                                ) ? (
                                  <>
                                    <Col md={6}>
                                      <Row className="align-items-center">
                                        <Col lg={4}>
                                          <label className="fs-16 fw-500 mb-lg-0 mb-3 required">
                                            How many pieces are in a cartoon?
                                          </label>
                                        </Col>
                                        <Col lg={5}>
                                          <div
                                            className={clsx(
                                              'input-group input-group-solid min-h-60px border',
                                              generalDataValidation
                                                .combinations[index].dimensions
                                                .cartoonPieces
                                                ? 'border-danger'
                                                : ''
                                            )}
                                          >
                                            <input
                                              type="text"
                                              className="form-control form-control-lg border-0 bg-white text-black fs-16 fw-500"
                                              placeholder="Type here..."
                                              value={
                                                val.dimensions.cartoonPieces
                                              }
                                              onChange={(event: any) => {
                                                handleChange(
                                                  event.target.value,
                                                  index,
                                                  'cartoonPieces'
                                                );
                                              }}
                                              onKeyPress={(event: any) => {
                                                handleOnKeyPress(event, index);
                                              }}
                                            />
                                            <span
                                              className="input-group-text fs-16 fw-500 text-gray bg-white border-0 text-gray fs-16 fw-500"
                                              id="basic-addon1"
                                            >
                                              pieces
                                            </span>
                                          </div>
                                        </Col>{' '}
                                      </Row>
                                    </Col>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Row>
                    </Card.Body>
                    {val.dimensions.product[0].isChecked ||
                    val.dimensions.product[1].isChecked ? (
                      <Card.Body
                        className={clsx(
                          'border border-top-0 bg-light p-0',
                          generalDataValidation.combinations[index].validation
                            ? 'border-danger'
                            : ''
                        )}
                      >
                        {renderCartoonDetails(
                          val.dimensions,
                          index,
                          generalDataValidation.combinations[index].dimensions
                        )}
                      </Card.Body>
                    ) : (
                      <></>
                    )}
                    {val.dimensions.product[2].isChecked ? (
                      <>
                        <Card.Body
                          className={clsx(
                            'border border-top-0 bg-light p-0',
                            generalDataValidation.combinations[index].validation
                              ? 'border-danger'
                              : ''
                          )}
                        >
                          {renderDozenDetails(
                            val.dimensions,
                            index,
                            generalDataValidation.combinations[index].dimensions
                          )}
                        </Card.Body>
                      </>
                    ) : (
                      <></>
                    )}
                    {val.dimensions.product[3].isChecked ? (
                      <>
                        <Card.Body
                          className={clsx(
                            'border border-top-0 bg-light p-0 border-r10px-bottom',
                            generalDataValidation.combinations[index].validation
                              ? 'border-danger'
                              : ''
                          )}
                        >
                          {renderPiecesDetails(
                            val.dimensions,
                            index,
                            generalDataValidation.combinations[index].dimensions
                          )}
                        </Card.Body>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </Card>
            </>
          );
        })}
      {/* {generalDataValidation.minimumCombinations ? (
        <div className="col-12 d-flex justify-content-center">
          <span className="text-danger">
            Please select atleast one combination
          </span>
        </div>
      ) : (
        <></>
      )} */}
    </>
  );
};
export default PriceDimesions;
